import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import './index.css';
import App from './App';
import { UserProvider } from './components/UserContext';
import { SpotlightProvider } from './context/SpotlightContext';
import { initAnalytics } from './services/analytics';
import reportWebVitals from './reportWebVitals';

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <SpotlightProvider>
        <UserProvider>
          <App />
        </UserProvider>
      </SpotlightProvider>
    </PostHogProvider>
  </React.StrictMode>,
  // document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
